import { useEffect } from 'react';
import gsap from 'src/utils/gsapSetup';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

type Options = {
  contentClass: string;
  smooth?: number;
  smoothTouch?: number;
  normalizeScroll?: boolean;
  ignoreMobileResize?: boolean;
  effects?: boolean;
  enabled?: boolean;
};

export function useScrollSmoother({
  contentClass,
  smooth = 4,
  smoothTouch = 0.5,
  normalizeScroll = true,
  ignoreMobileResize = true,
  effects = true,
  enabled = true,
}: Options) {
  useEffect(() => {
    const smoother = ScrollSmoother.get();

    // ❌ DISABLED CASE → kill existing smoother
    if (!enabled) {
      if (smoother) {
        smoother.kill();
      }
      return;
    }

    if (!smoother) {
      const ctx = gsap.context(() => {
        ScrollSmoother.create({
          wrapper: '#smooth-wrapper',
          content: `.${contentClass}`,
          smooth,
          smoothTouch,
          normalizeScroll,
          ignoreMobileResize,
          effects,
        });
      });

      return () => {
        ctx.revert();
      };
    }
  }, [contentClass, smooth, smoothTouch, normalizeScroll, ignoreMobileResize, effects, enabled]);
}
